import React, { useMemo } from 'react'
import useAppStore from '@/store/useAppStore'
import { MODAL_WINDOW_TYPE } from '@/data/constants/constants'
import objectHash from 'object-hash'
import ArchiveVault from '../components/vault/ArchiveVault'
import UnableToArchive from '../components/vault/UnableToArchive'
import ArchiveEmptyVault from '../components/vault/ArchiveEmptyVault'
import ArchiveCategory from '../components/transactionCategory/ArchiveCategory'
import ArchiveEmptyCategory from '../components/transactionCategory/ArchiveEmptyCategory'
import CreateModel from '../components/model/CreateModel'
import ConfirmationModal from '../components/ConfirmationModal'

export default function useOpenModalWindow() {
  const setModalWindowState = useAppStore((state) => state.setModalWindowState)
  const setModalProps = useAppStore((state) => state.setModalProps)
  const modalProps = useAppStore((state) => state.modalProps)
  const resetStore = useAppStore((state) => state.reset)

  const setModalWindowType = useAppStore((state) => state.setModalWindowType)
  const modalWindowType = useAppStore((state) => state.modalWindowType)

  const openModal = ({ name, ...params }) => {
    setModalWindowState('opened')
    setModalWindowType(name)
    setModalProps(params)

  }

  const closeModal = () => {
    setModalWindowState('closed')
    setModalWindowType(null)
    setModalProps({})
    resetStore()
  }

  const modalComponent = useMemo(() => {
    const componentMap = {
      [MODAL_WINDOW_TYPE.ARCHIVE_VAULT]: ArchiveVault,
      [MODAL_WINDOW_TYPE.UNABLE_TO_ARCHIVE]: UnableToArchive,
      [MODAL_WINDOW_TYPE.EMPTY_VAULT_ARCHIVE]: ArchiveEmptyVault,
      [MODAL_WINDOW_TYPE.ARCHIVE_CATEGORY]: ArchiveCategory,
      [MODAL_WINDOW_TYPE.ARCHIVE_EMPTY_CATEGORY]: ArchiveEmptyCategory,
      [MODAL_WINDOW_TYPE.CREATE_MODEL]: CreateModel,
      [MODAL_WINDOW_TYPE.CONFIRMATION_MODAL]: ConfirmationModal,
    }

    const Comp = componentMap[modalWindowType]
    const key = objectHash(setModalProps)
    return Comp ? <Comp key={key} {...setModalProps} /> : null
  }, [modalWindowType, modalProps])

  return { openModal, closeModal, modalComponent }
}
